import { Component, Input } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TooltipDirective } from '../../../directives/tooltip.directive';

@Component({
  selector: 'i-tooltip',
  imports: [NgbTooltipModule, TooltipDirective],
  templateUrl: './itooltip.component.html',
  styleUrl: './itooltip.component.scss'
})
export class ITooltipComponent {
 @Input('tooltip') tooltipKey: string = '';
}
